export interface PusherCallback {
  eventType: string;
  eventPayload: unknown;
  channel?: string;
}

export const toPusherCallback = (
  eventType: string,
  eventPayload?: unknown,
  channel?: string,
): PusherCallback => ({
  eventType,
  eventPayload,
  channel,
});

export const PUSHER_SUBSCRIPTION_CALLBACK_TYPES = {
  subscriptionSucceeded: 'pusher_subscription_succeeded',
  subscriptionError: 'pusher_subscription_error',
  subscriptionCount: 'pusher_subscription_count',
} as const;

export const PUSHER_CONNECTION_CALLBACK_TYPES = {
  connected: 'pusher_connected',
  disconnected: 'pusher_disconnected',
} as const;
